const TabletsEvent = {
  fetchAll: 'tablets/fetch-all'
}

export default TabletsEvent
